import { createLocalVue, shallowMount } from '@vue/test-utils';
import Vuex from 'vuex';
import Vuelidate from 'vuelidate';
import '@babel/polyfill';

jest.mock('../../../services/vueCustomerSvc');
import { createCustomerFromEmailCapture } from '../../../services/vueCustomerSvc';

/**** TEST MODULE ****/
import CartEmailCaptureModal from './CartEmailCaptureModal';

/**** MOUNTING OPTIONS ****/
function createWrapper() {
  const localVue = createLocalVue();
  localVue.use(Vuex);
  localVue.use(Vuelidate);
  return shallowMount(CartEmailCaptureModal, {
    attachToDocument,
    localVue,
    mocks,
    methods,
    provide,
    stubs,
    store
  });
}

let attachToDocument = false;
const loadCartMock = jest.fn();

const methods = {};
const mocks = {};
const provide = {};
const stubs = {};
const store = {
  cart: {
    namespaced: true,
    actions: {
      loadCart: loadCartMock
    }
  }
};

/**** TESTS ****/

describe('CartEmailCaptureModal', function() {
  let wrapper;

  beforeEach(function() {
    wrapper = createWrapper();
  });

  describe('submitting an email for capture', function() {
    it('calls createCustomerFromEmailCapture only if the email input is valid', function() {
      createCustomerFromEmailCapture.mockReturnValue(Promise.resolve({data: {numOrders: 0}}));
      const submitBtn = wrapper.find('.submit');

      submitBtn.trigger('submit');
      expect(createCustomerFromEmailCapture).toHaveBeenCalledTimes(0);
      expect(wrapper.contains('.form-fields')).toBe(true);
      expect(wrapper.contains('.error')).toBe(false);
      expect(wrapper.contains('.success')).toBe(false);

      wrapper.setData({'email': 'yesThisisEmail@madison-reed.com'});
      wrapper.vm.$forceUpdate();

      submitBtn.trigger('submit');
      expect(createCustomerFromEmailCapture).toHaveBeenCalledTimes(1);
    });
  });

  describe('after submitting email for capture', function() {
    test('success state', () => {
      wrapper.setData({'emailCaptureResponse': 0});
      expect(wrapper.contains('.success')).toBe(true);
      expect(wrapper.contains('.form-fields')).toBe(false);
      expect(wrapper.contains('.error')).toBe(false);
    });

    test('error state', function() {
      wrapper.setData({'emailCaptureResponse': 1});
      expect(wrapper.contains('.error')).toBe(true);
      expect(wrapper.contains('.form-fields')).toBe(false);
      expect(wrapper.contains('.success')).toBe(false);
    });
  });

  test('close', function() {
    wrapper.setData({emailCaptureResponse: null});
    const closeButton = wrapper.find('.cancel');
    closeButton.trigger('click');
    expect(wrapper.emitted('hide-modal')).toBeTruthy();
  });
});